module.exports = __webpack_public_path__ + "static/img/1.61427fe.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/1.jpg
// module id = zRwx
// module chunks = 25